import { APICore } from './apiCore';

const api = new APICore();


/* CREATE REPLY */
export function Createkeyword(formData: FormData): Promise<any> {
    return api.create('/keyword_action', formData);
}

/* LIST */
export function show_keyword() {
    return api.show('/keyword_action/list');
}

/* DETAILS */

export function delete_keyword(id: string) {
    return api.get(`/keyword_action/${id}`);
}

/* UPDATE */
export function update_keyword(id: string, data: FormData) {
    return api.create(`/keyword_action/${id}`, data);
}
